<template>
  <div class="process">
    <headers></headers>
    <div class="banner">
      <img src="../assets/banner@2x.png" width="100%" alt />
      <el-row class="banner_z">
        <el-col :span="4" :offset="9">
          <div>
            <p>让管理</p>
            <p>都变得更轻松</p>
            <p>经理云生态管理平台</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <img src="../assets/yj.png" alt width="100%" />
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 产品功能 -->
    <main style="padding-top:30px;">
      <div class="main-top">
        <h2>产品功能</h2>
      </div>
      <el-row class="main-top1">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h3 style="font-weight: 800;font-size: 36px;margin-bottom: 18px;">产品功能</h3>
            <p style="font-size: 16px;">PRODUCT FUNCTION</p>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="main-top2">
          <div class="grid-content bg-purple-dark">
            <h4>收银机 加工中心管理</h4>
            <p>从下单到加工完毕一整套省事省时的操作流程</p>
          </div>
        </el-col>
      </el-row>

      <el-row style="padding-bottom:30px;">
        <el-col class="gundongtiao">
          <div class="grid-content bg-purple-dark liuchen" style="min-width:1000px;margin: 0 auto;">
            <ul style="display:flex;justify-content: center;">
              <li>
                <i>
                  <img src="../assets/新建加工单@2x.png" alt />
                </i>
                <p>新建加工单</p>
              </li>
              <li>
                <span>
                  <img src="../assets/流程@2x.png" alt />
                </span>
              </li>
              <li>
                <i>
                  <img src="../assets/加工中心@2x.png" alt />
                </i>
                <p>
                  加工中心
                  <br />接收加工单
                </p>
              </li>
              <li>
                <span>
                  <img src="../assets/流程@2x.png" alt />
                </span>
              </li>
              <li>
                <i>
                  <img src="../assets/加工师加工@2x(1).png" alt />
                </i>
                <p>加工师加工</p>
              </li>
              <li>
                <span>
                  <img src="../assets/流程@2x.png" alt />
                </span>
              </li>
              <li>
                <i>
                  <img src="../assets/成品检测@2x(1).png" alt />
                </i>
                <p>成品检测</p>
              </li>
              <li>
                <span>
                  <img src="../assets/流程@2x.png" alt />
                </span>
              </li>
              <li>
                <i>
                  <img src="../assets/商品派送@2x.png" alt />
                </i>
                <p>商品派送</p>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </main>
    <!-- 技术规格 -->
    <div class="science">
      <div class="smallscience">
        <h2>技术规格</h2>
      </div>
      <el-row class="science_top">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h4>收银机 技术规格</h4>
            <p>全功能触摸一体收银机</p>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col class="smalllunbotu" :xs="{span:16,offset:4}">
          <img src="../assets/tu@2x.png" alt width="100%" />
        </el-col>
        <el-col :sm="{span:6,offset:6}" :xs="{span:24,offset:4}" class="xiangqing">
          <div class="grid-content bg-purple science_left">
            <p>技术规格</p>
            <p>主显显示屏：15.6寸电容触摸</p>
            <p>客显显示屏：9寸宽视角</p>
            <p>&nbsp;</p>
            <p>系统：Android6.0.1</p>
            <p>主频：1.8GHZ</p>
            <p>内存：2G</p>
            <p>闪存：8GB</p>
            <p>通讯：以太网/WIFI/蓝牙</p>
            <p>内置打印机装纸容量：直径80MM</p>
            <p>打印速度：260MM/秒</p>
          </div>
        </el-col>
        <el-col :sm="{span:7}" class="lunbotu">
          <div class="grid-content bg-purple-light">
            <el-carousel indicator-position="outside">
              <el-carousel-item>
                <img src="../assets/tu@2x.png" alt width="100%" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/tu@2x.png" alt width="100%" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/tu@2x.png" alt width="100%" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
      </el-row>

      <el-row style="margin-top:10px;">
        <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
          <el-row>
            <el-col :span="8" :xs="{span:24,offset:4}">
              <div class="yyy">
                <img src="../assets/材料@2x.png" alt width="20px;" />
                <span>主显示屏采用军工级别铝合金材料</span>
              </div>
            </el-col>
            <el-col :span="8" :xs="{span:24,offset:4}">
              <div class="yyy">
                <img src="../assets/塑料@2x.png" alt width="20px;" />
                <span>机器壳身采用高强度abs塑料</span>
              </div>
            </el-col>
            <el-col :span="8" :xs="{span:24,offset:4}">
              <div class="yyy">
                <img src="../assets/小票打印机@2x.png" alt width="20px;" />
                <span>自带切纸功能的热敏小票打印机</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!-- 特色功能 -->
    <div class="feature">
      <div class="feature_top">
        <h2>特色功能</h2>
      </div>
      <el-row style class="feature-top">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h4 style>特色功能</h4>
            <p style>为眼镜行业专业定制</p>
          </div>
        </el-col>
      </el-row>

      <el-row class="feature-content">
        <el-col :span="24" style="display: flex;justify-content: center;">
          <div class="bigbox-left">
            <div class="boxs">
              <p>
                <img src="../assets/下单@2x.png" alt width="57px" />
              </p>
              <p style="font-size: 24px; margin: 14px 0 20px 0;">新建加工单</p>
              <p style="font-size: 20px;color:#666;">
                商家可在pda/微信服务号/商家版收
                <br />银机下加工单；加工中心自行下加工单。
              </p>
            </div>
            <div class="boxs">
              <p>
                <img src="../assets/jgsfjg.png" alt width="64px" />
              </p>
              <p style="font-size: 24px; margin:  14px 0 20px 0;">加工师加工</p>
              <p style="font-size: 20px;color:#666;">
                商品检测完成后，加工中心根据加工
                <br />要求加工工艺进行加工。
              </p>
            </div>
          </div>

          <div class="boxs_z">&nbsp;</div>

          <div class="bigbox-right">
            <div class="boxs">
              <p>
                <img src="../assets/spcr.png" alt width="64px" />
              </p>
              <p style="font-size: 24px; margin:  14px 0 20px 0;">商品检测</p>
              <p style="font-size: 20px;color:#666;">
                加工单接收后，加工中心上门取货或者
                <br />从仓库取货，进行检测。
              </p>
            </div>
            <div class="boxs">
              <p>
                <img src="../assets/成品检测@2x.png" alt width="64px" />
              </p>
              <p style="font-size: 24px; margin:  14px 0 20px 0;">成品检测</p>
              <p style="font-size: 20px;color:#666;">
                商品加工完成后，进行成品检测，商品
                <br />合格则派送到商家，若不合格则退回。
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 移动端 -->
      <div class="smallfeature">
        <ul>
          <li>
            <p>
              <img src="../assets/下单@2x.png" alt />
              <span>新建加工单</span>
            </p>
            <p>商家可在pda/微信服务号/商家版收银机下加工单；加工中心自行下加工单。</p>
          </li>
          <li>
            <p>
              <img src="../assets/jgsfjg.png" alt />
              <span>加工师加工</span>
            </p>
            <p>商品检测完成后，加工中心根据加工要求加工工艺进行加工。</p>
          </li>
          <li>
            <p>
              <img src="../assets/spcr.png" alt />
              <span>商品检测</span>
            </p>
            <p>加工单接收后，加工中心上门取货或者从仓库取货，进行检测。</p>
          </li>
          <li>
            <p>
              <img src="../assets/成品检测@2x.png" alt />
              <span>成品检测</span>
            </p>
            <p>商品加工完成后，进行成品检测，商品合格则派送到商家，若不合格则退回。</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 样机细节展示 -->
    <div class="proto">
      <div class="smallproto">
        <h2>样机细节展示</h2>
      </div>
      <el-row class="proto_top">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h4>样机细节展示</h4>
            <p>带给您不一样的视觉体验</p>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div class="proto_b">
            <img src="../assets/yangji.png" alt />
            <br />
            <img src="../assets/1Pro3-1@2x.png" width="620px" alt />
            <br />
            <img src="../assets/1Pro3-2@2x.png" width="620px" alt />
            <br />
            <img src="../assets/1Pro3-3@2x.png" width="620px" alt />
          </div>
        </el-col>
      </el-row>
    </div>
    <footers></footers>
  </div>
</template>

<script>
import header from "../components/headers";
import footer from "../components/footer";
import Swiper from "swiper";
import "../../node_modules/swiper/dist/css/swiper.min.css";
export default {
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      direction: "horizontal",
      slidesPerView: "auto",
      freeMode: true,
      roundLengths: true //防止文字模糊
    });
  },
  components: {
    headers: header,
    footers: footer
  }
};
</script>

<style lang="less" scoped>
.process {
  .banner {
    position: relative;
    .banner_z {
      color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      p {
        // overflow: hidden;
        // text-overflow: ellipsis;
        white-space: nowrap;
        &:nth-of-type(1) {
          font-size: 60px;
          margin-top: 30px;
          font-weight: 600;
        }
        &:nth-of-type(2) {
          font-size: 48px;
          font-weight: 600;
        }
        &:nth-of-type(3) {
          font-size: 30px;
          margin-top: 14px;
          font-weight: 600;
        }
      }
      @media screen and (max-width: 1430px) {
        p {
          &:nth-of-type(1) {
            font-size: 40px;
            margin-top: 30px;
            font-weight: 600;
          }
          &:nth-of-type(2) {
            font-size: 30px;
            font-weight: 600;
          }
          &:nth-of-type(3) {
            font-size: 20px;
            margin-top: 14px;
            font-weight: 600;
          }
        }
      }
      @media screen and (max-width: 850px) {
        p {
          &:nth-of-type(1) {
            font-size: 12px;
            margin-top: 6px;
            font-weight: 600;
          }
          &:nth-of-type(2) {
            font-size: 11px;
            font-weight: 600;
          }
          &:nth-of-type(3) {
            font-size: 9px;
            margin-top: 5px;
            font-weight: 600;
          }
        }
      }
    }
  }
  main {
    @media screen and (max-width: 850px) {
      .main-top {
        display: block;
      }
      .main-top1 {
        display: none;
      }
    }
    @media screen and (min-width: 850px) {
      .main-top {
        display: none;
      }
      .main-top1 {
        display: block;
      }
    }
    background-color: #fff;
    .main-top {
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;

        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
    }
    .main-top2 {
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
      }
      p {
        font-size: 18px;
      }
      @media screen and (max-width: 850px) {
        h4 {
          font-size: 14px;
          margin-bottom: 9px;
        }
        p {
          font-size: 9px;
        }
      }
    }
    .el-row {
      // margin: 40px 0;
      margin-top: 40px;
      text-align: center;
    }
    .liuchen {
      ul {
        li {
          // width: 6%;
          float: left;
          margin: 0 10px;
          span {
            img {
              margin: 50px 0;
            }
          }
          i {
            img {
              cursor: pointer;
              transition: all 0.5s;
              &:hover {
                transform: scale(1.08);
              }
            }
          }
          p {
            font-size: 18px;
            margin-top: 5px;
          }
        }
      }
    }
    @media screen and (max-width: 850px) {
      .gundongtiao {
        overflow-x: scroll;
        .liuchen {
          p {
            font-size: 12px;
          }
        }
      }
    }
  }
  .science {
    @media screen and (max-width: 850px) {
      .smallscience {
        display: block;
        h2 {
          font-size: 16px;
          color: #2e2e2e;
          font-weight: 400;
          margin: 11px 0;
          position: relative;
          padding-left: 28px;

          &::after {
            content: "";
            background-color: #258ffc;
            border-radius: 5.5px;
            width: 4px;
            height: 16px;
            overflow: hidden;
            position: absolute;
            top: 3px;
            left: 13px;
          }
        }
      }
      .lunbotu {
        display: none;
      }
      .smalllunbotu {
        display: block;
      }
      .xiangqing {
        margin-top: 40px;
        margin-bottom: 40px;
      }
    }
    @media screen and (min-width: 850px) {
      .smallscience {
        display: none;
      }
      .lunbotu {
        display: block;
      }
      .smalllunbotu {
        display: none;
      }
    }
    background-color: #f0efef;
    padding: 50px 0;
    padding-bottom: 100px;
    .science_top {
      text-align: center;
      margin: 40px 0;
      margin-top: -20px;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
        margin-top: 30px;
      }
      p {
        font-size: 18px;
      }
      @media screen and (max-width: 850px) {
        h4 {
          font-size: 14px;
          margin-bottom: 9px;
        }
        p {
          font-size: 9px;
        }
      }
    }
    .science_left {
      p {
        line-height: 25px;
      }
    }
    .yyy {
      padding: 10px 0;
      cursor: pointer;
      transition: all 1s;
      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 3px 3px #eee;
      }
      img {
        margin-right: 5px;
        vertical-align: middle;
      }
      span {
        color: #2891fc;
        vertical-align: middle;
      }
    }
  }
  .feature {
    @media screen and (max-width: 850px) {
      .feature-top {
        display: none;
      }
      .feature_top {
        display: block;
      }
      .feature-content {
        display: none;
      }
      .smallfeature {
        display: block;
      }
    }
    @media screen and (min-width: 850px) {
      .feature-top {
        display: block;
      }
      .feature_top {
        display: none;
      }
      .feature-content {
        display: block;
      }
      .smallfeature {
        display: none;
      }
    }
    .feature_top {
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;

        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
    }
    .feature-top {
      margin: 80px 0;
      text-align: center;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
      }
      p {
        font-size: 18px;
      }
    }
    .bigbox-left {
      float: left;
      width: 440px;
      margin-right: 47px;
    }
    .bigbox-right {
      float: left;
      width: 440px;
    }
    .boxs {
      float: left;
      padding: 30px 40px;
      cursor: pointer;
      margin-bottom: 50px;
      width: 440px;
      border-radius: 4px;
      &:hover {
        transform: translate(-5px, -5px);
        transition: all 1s;
        box-shadow: 0px 0px 15px #d2e8ff;
      }
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .boxs_z {
      width: 1px;
      height: 520px;
      background-color: #d2d2d2;
      float: left;
      margin-right: 57px;
    }
    // 移动端
    .smallfeature {
      padding: 15px;
      ul {
        overflow: hidden;
        padding: 0 40px;
        li {
          margin-bottom: 40px;
          p {
            font-size: 12px;
            vertical-align: middle;
            img {
              width: 37px;
              vertical-align: middle;
            }
            span {
              font-weight: 600;
              margin-left: 10px;
            }
            &:nth-of-type(2) {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }

  .proto {
    background-color: #fff;
    padding: 40px 0;
    .smallproto {
      @media screen and (min-width: 850px) {
        display: none;
      }
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;

        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
    }
    .proto_top {
      text-align: center;
      margin: 40px 0;
      margin-top: -20px;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
        margin-top: 30px;
      }
      p {
        font-size: 18px;
      }
      @media screen and (max-width: 850px) {
        h4 {
          font-size: 14px;
          margin-bottom: 9px;
        }
        p {
          font-size: 9px;
        }
      }
    }
    .proto_b {
      text-align: center;
      @media screen and (max-width: 850px) {
        img {
          width: 100%;
          &:nth-of-type(1) {
            width: 70%;
          }
        }
      }

      img {
        margin: 40px 0;
        transition: all 1s;
        cursor: pointer;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
}
</style>